import request from 'helpers/request'
import { includes } from 'lodash'
import { toList, toSingle } from './transformer'

export default {
    list: async resource => {
        const resp = await request.get(resource)
        const { meta = {}, data = [], pagination = {}, included = [] } = resp
        const mapped = toList(data, included)

        return {
            meta,
            pagination,
            data: mapped,
        }
    },
    single: async resource => {
        const resp = await request.get(resource)
        const { meta = {}, data = {}, included = [] } = resp
        const mapped = toSingle(data, included)

        return {
            meta,
            data: mapped,
        }
    },
    singleWebHook: async resource => {
        const resp = await request.get(resource)
        const { meta = {}, data = {} } = resp
        return {
            meta,
            data: data,
        }
    },
    update: async (resource, data, type = '') => {
        return await request.patch(
            `${resource}`,
            type === 'socmed' ? data : { data }
        )
    },

    insert: async (resource, data) => {
        //spreaded data, ...data, for /api endpoint
        const dataParam = includes(resource, 'api/') ? { ...data } : { data }
        return await request.post(`${resource}`, dataParam)
    },
    register: async (resource, params) => {
        const data = {
            provider: 'local',
            data: {
                email: params.email,
                password: params.password,
                extras: {
                    name: params.name,
                    address: params.address,
                    phone: params.phone,
                    regency: params.regency,
                },
            },
        }

        const result = await request.post(`${resource}`, data)
        return result
    },
    upload: async (resource, data, type, extraParams) =>
        await request.put(resource, data, 'upload', type, extraParams),
    put: async (resource, data) => await request.put(resource, data, '', ''),
    delete: async resource => await request.delete(resource),
    external: async resource => await request.get(resource, 'external'),
}
